import { ImageProcessingOptions } from 'runtime/data/imageprocessingoptions';

export class FileUploadStartRequested {
    static eventName() { return 'FileUploadStartRequested'; }
    eventName = FileUploadStartRequested.eventName;

    constructor(public transferId: string, public source: any, public imageOptions: ImageProcessingOptions, public fileNameOverride: string) {}
}